import React, { useState } from 'react';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import MuiExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import { Popover, Fade, ClickAwayListener, List, ListItem, ListItemText } from '@material-ui/core';
import Popup from '../../Modal/PopUp';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import EditLawyer from '../../AddLawyers/EditLawyer';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import { deleteLawyerFirm } from '../../../store/actions/UserAction';
import Snackbar from '../../Snackbar';
import { MONTH_NUMBER } from '../../../utils/ConstantsMain';
import Moment from 'moment';
import 'moment/locale/es';
import { extendMoment } from 'moment-range';
import './LawyerAdded.scss';

const moment = extendMoment(Moment);

const ExpansionPanel = withStyles({
  root: {
    boxShadow: 'none',
    marginBottom: 16,
    borderRadius: 4,
    backgroundColor: 'white',
    border: '1px solid #e7e7e7',
    marginTop: 8,
    padding: 0,
    '&$expanded': {
      '&:first-child': {
        marginTop: 24,
      },
    },
  },
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  root: {
    padding: 0,
    minHeight: 56,
    position: 'relative',
  },
  content: {
    margin: 0,
    width: '100%',
    padding: 24,
    '@media screen and (max-width:768.98px)': {
      height: 160,
    },
    '@media (max-width: 425px)': {
      padding: 16,
    },
    '&$expanded': {
      margin: 0,
      padding: '32px 24px 16px',
    },
  },
  expandIcon: {
    color: '#6ecc47',
    alignSelf: 'flex-start',
    position: 'absolute',
    right: 16,
  },
})(MuiExpansionPanelSummary);

const ExpansionPanelDetails = withStyles({
  root: {
    color: '#484848',
    display: 'block',
    padding: '0 16px 24px 24px',
  },
})(MuiExpansionPanelDetails);

const useStyles = makeStyles({
  popper: {
    width: 120,
    margin: '0 24px 0 0',
    boxShadow: isMobile ? 'initial' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
    backgroundColor: isMobile ? 'initial' : '#f5f5f5',
  },
  list: {
    width: 120,
    backgroundColor: 'white'
  },
  listItem: {
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  listItemText: {
    color: '#484848',
    fontSize: 14,
  }
})

function LawyerAdded({ 
  nElem,
  uid,
  allLayers,
  deleteLawyerFirm,
  elements,
  preview,
  handleSnack,
  alreadyRewarded,
  handleRewarded,
  handleTrophieModalOpen,
}) {
  const [flagEdit, setFlagEdit] = useState(0);

  const FnEditLawyer = () => {
    setFlagEdit(1)
    setAnchorEl(null)
  };

  const changeStatus = (isActive) => {
    setFlagEdit(0);
  };

  const [ openExpand, setOpenExpand ] = useState(false)

  const handleOpenExpand = () => {
    setOpenExpand(true)
  }
  const handleCloseExpand = () => {
    setOpenExpand(false)
  }

  const tituloNombre = (auth) => {
    switch (auth.gradeStudy) {
      case 'Licenciatura': {
        return 'Lic.';
      }
      case 'Maestría': {
        if (auth.gender == 'male') {
          return 'Mtro.';
        } else if (auth.gender == 'female') {
          return 'Mtra.';
        }
        return '';
      }
      case 'Especialidad':
        return 'Esp.';
      case 'Doctorado': {
        if (auth.gender == 'male') {
          return 'Dr.';
        } else if (auth.gender == 'female') {
          return 'Dra.';
        }
        return ''
      }
      default:
        return '';
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopper = (event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const [ outsideOpen, setOutsideOpen ] = useState(false)

  const handleOutside = () => {
    setOutsideOpen(!outsideOpen)
  }

  const confirmDeleteLawyer = event => {
    event.preventDefault()
    setOutsideOpen(false)
    deleteLawyerFirm(uid, nElem, allLayers).then(res => {
      handleSnack()
    });
    handleSnack()
  };

  const calculateYearsAndMonths = (month, year) => {
    const filteredMonth = MONTH_NUMBER.filter(elem => {
      if (elem.name === month) {
        return elem
      }
    })
    const years = moment().diff(`${year}-${filteredMonth[0].value}-01`, 'years');
    const months = moment().diff(`${year}-${filteredMonth[0].value}-01`, 'months');
    if (months <= 11) {
      if (months === 1) {
        return `1 mes`
      } else {
        return `${months} meses`
      }
    } else {
      if (years === 1) {
        return `1 año`
      } else {
        return `${years} años`
      }
    }
  };

  const someObjectInArray = (array) => {
    const allValues = Object.values(array[0])
    const evaluation = allValues.some(elem => {
      if (elem) {
        return true
      }
      return false
    })
    return evaluation;
  }

  const openPopper = Boolean(anchorEl);
  const classes = useStyles()
  return (
    <>
      <Popup
        open={outsideOpen}
        handleClose={handleOutside}
        title={['Seguro que deseas eliminar a', <br />, `${elements.nameLawyer} ${elements.firstLastname} ${elements.secondLastName}?`]}
        subtitle={`Si eliminas a ${elements.nameLawyer} ${elements.firstLastname} ${elements.secondLastName} se borrará de tu lista de miembros del equipo, para regresar presiona el botón Cancelar `}
        primaryButton={true}
        primaryButtonVariant='primarySolidOutlined'
        primaryButtonText='Sí, eliminar'
        primaryFunction={confirmDeleteLawyer}
        secondaryButton={true}
        secondaryOptionalFunctionForCancel={() => setAnchorEl(null)}
        secondaryButtonVariant='primary'
      />
      <div style={{ width: '100%' }}>
        {elements && flagEdit === 0 ? (
        <ExpansionPanel
          expanded={openExpand}
        >
          <ExpansionPanelSummary>
            <section className="cardAsocia">
              {preview && preview ? ('') : (
                  <img
                    className="cardAsocia_edit"
                    src="/img/expand/menu-options.svg"
                    alt="editar"
                    onClick={handlePopper}
                  />
                )
              }
              <Popover
                open={openPopper}
                anchorEl={anchorEl}
                className={classes.popper}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                  vertical: 'center',
                  horizontal: 'right',
                }}
              >
                <List className={classes.list} component="nav" aria-label="secondary mailbox folders">
                  <ListItem
                    className={classes.listItem}
                    button
                  >
                    <ListItemText onClick={FnEditLawyer} className={classes.listItemText} primary="Editar" />
                  </ListItem>

                  <ListItem
                    className={classes.listItem}
                    button
                  >
                    <ListItemText onClick={handleOutside} className={classes.listItemText} primary="Eliminar" />
                  </ListItem>
                </List>                
              </Popover>
              <header className="cardAsocia_header">
                <figure className="cardAsocia_header_avatar">
                  <img className="cardAsocia_header_avatar_imgElement" src={elements.imgProfile ? elements.imgProfile : "/img/avatars/avatares-cuadro-h.svg"} alt={`${elements.nameLawyer} ${elements.firstLastname}`} />
                </figure>
                <div className="cardAsocia_header_title">
                  <p className="cardAsocia_header_title_name">
                    {`${tituloNombre(elements)} ${elements.nameLawyer} ${elements.firstLastname} ${elements.secondLastName}`}
                  </p>
                  {elements.specialties ?
                    <p className="cardAsocia_header_title_text">
                      {elements.specialties[0]}
                    </p>
                    :
                    ""
                  }
                </div>
              </header>
              <div>
                {!openExpand ?
                  <div
                    onClick={handleOpenExpand}
                    className="cardAsocia_expandMoreContainer"
                  >
                    <p className="cardAsocia_expandMore-paragraph">Ver más</p>
                    <img src="/img/expand/drop-down.svg" alt="Ver más" />
                  </div> :
                  null
                }
              </div>
            </section>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <section className="cardAsocia">
              <div className="cardAsocia_info">
                <p className="cardAsocia_info_title">Datos personales del titular</p>
                {elements && elements.specialties &&
                  <div className="cardAsocia_data">
                    <div className="cardAsocia_data_field">

                      {elements && elements.gender ?
                        <div className="cardAsocia_dataContainer">
                          <p className="cardAsocia_data_field_title">Género</p>
                          <div className="cardAsocia_data_field_text">
                            <p>
                              {elements.gender === 'male' ?
                                'Masculino' :
                                'Femenino'
                              }
                            </p>
                          </div>
                        </div> :
                        null
                      }

                      {elements && elements.gradeStudy ?
                        <div className="cardAsocia_dataContainer">
                          <p className="cardAsocia_data_field_title">Último grado de estudios</p>
                          <div className="cardAsocia_data_field_text">
                            <p>{elements.gradeStudy}</p>
                          </div>
                        </div> :
                        null
                      }

                      {elements && elements.cedula ?
                        <div className="cardAsocia_dataContainer">
                          <p className="cardAsocia_data_field_title">Cédula Profesional</p>
                          <div className="cardAsocia_data_field_text">
                            <p>{elements.cedula}</p>
                          </div>
                        </div> :
                        null
                      }

                      {elements.specialties && elements.specialties.length === 1 ?
                        <p className="cardAsocia_data_field_title">Especialidad</p> :
                        <p className="cardAsocia_data_field_title">Especialidades</p>
                      }
                      <div className="cardAsocia_espe">
                        <ul>
                          {elements.specialties && elements.specialties.map((specialty, index) => 
                            <li key={index}>{specialty}</li>
                          )}
                        </ul>
                      </div>

                      {elements && elements.education && elements.education.length >= 1 &&
                        <>
                          {someObjectInArray(elements.education) === true &&
                            <>
                              <p className="cardAsocia_data_field_title2">Educación</p>
                              <div className="cardAsocia_education">
                                <ul>
                                  {elements.education && elements.education.map((educationItem, index) => {
                                    const {nameUniversity, receivedGradeStudy, discipline, firstYear, lastYear} = educationItem;
                                    return (
                                      <li key={index}>
                                        <div>
                                          {nameUniversity ?
                                            <p>{nameUniversity}</p> :
                                            null
                                          }
                                          {receivedGradeStudy && discipline ?
                                            <p>{receivedGradeStudy}, {discipline}</p> :
                                            null
                                          }
                                          {firstYear && lastYear ?
                                            <p>{firstYear} - {lastYear}</p> :
                                            null
                                          }
                                        </div>
                                      </li>)
                                    }
                                  )}
                                </ul>
                              </div>
                            </>
                          }
                        </>
                      }

                      {elements && elements.laboral && elements.laboral.length >= 1 &&
                        <>
                          {someObjectInArray(elements.laboral) === true &&
                            <>
                              <p className="cardAsocia_data_field_title2">Experiencia Laboral</p>
                              <div className="cardAsocia_laboral">
                                <ul>
                                  {elements.laboral && elements.laboral.map((laboralItem, index) => {
                                    const {companyPosition, nameCompany, actualCompanyPosition, firstMonth, firstLaboralYear, lastMonth, lastLaboralYear} = laboralItem;
                                    return (
                                      <li key={index}>
                                        <div>
                                          {companyPosition ?
                                            <p>{companyPosition}</p> :
                                            null
                                          }
                                          {nameCompany ?
                                            <p>{nameCompany}</p> :
                                            null
                                          }
                                          {firstMonth && firstLaboralYear && lastMonth && lastLaboralYear ?
                                            <p>{firstMonth.slice(0, 3)}. de {firstLaboralYear} - {lastMonth.slice(0, 3)}. de {lastLaboralYear}</p> :
                                          firstMonth && firstLaboralYear && actualCompanyPosition ?
                                            <div className="containerMoreDataAdded">
                                              <p className="moreDataAdded">{firstMonth.slice(0, 3)}. de {firstLaboralYear} - Actualidad</p>
                                              <p>{calculateYearsAndMonths(firstMonth, firstLaboralYear)}</p>
                                            </div> :
                                          firstMonth && firstLaboralYear ?
                                            <p>{firstMonth.slice(0, 3)}. de {firstLaboralYear}</p> :
                                            null
                                          }
                                        </div>
                                      </li>)
                                    }
                                  )}
                                </ul>
                              </div>
                            </>
                          }
                        </>
                      }

                      {openExpand ?
                        <div
                          onClick={handleCloseExpand}
                          className='cardAsocia_expandLess'
                        >
                          <p className='cardAsocia_expandLess-paragraph'>Ver menos</p>
                          <img src="/img/expand/drop-up.svg" alt="Ver menos" />
                        </div> :
                        null
                      }
                    </div>
                  </div>}
              </div>
            </section>
          </ExpansionPanelDetails>
        </ExpansionPanel>)
  : (
      <div>
        <EditLawyer
          elements={elements}
          outsideOpen={outsideOpen}
          handleOutside={handleOutside}
          evento={changeStatus}
          setFlagEdit={setFlagEdit}
          item={nElem}
          allLayers={allLayers}
          handleSnack={handleSnack}
          alreadyRewarded={alreadyRewarded}
          handleRewarded={handleRewarded}
          handleTrophieModalOpen={handleTrophieModalOpen}
        />  
      </div>
    )
  }
      </div>
    </>
  );
}

const mapDispatchToProps = dispatch => ({
  deleteLawyerFirm: (uid, item, allLayers) =>
    dispatch(deleteLawyerFirm(uid, item, allLayers)),
})

const mapStateToProps = state => ({
  uid: state.authClient.uid,
})

export default connect(mapStateToProps, mapDispatchToProps)(LawyerAdded);